<template>
  <div v-if="cert_data != null">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <center>
      <v-btn class="button no-display" @click="print"> Print </v-btn>
      <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
    </center>
    <template>
      <div v-if="show == true" ref="document">
        <!-- {{org_basic_data}} -->
        <div
          class="printdiv v-card"
          style="
            border: 3px solid;
            border-color: black;
            position: absolute;
            padding: 10px;
            margin-left: 6%;
            margin-right: 6%;
            margin-top: 5%;
          "
        >
          <v-row justify="center">
            <v-col cols="12" sm="2" md="2" align="right">
              <img
                v-if="org_basic_data.trust_logo"
                :src="org_basic_data.trust_logo"
                width="75%"
                alt="logo"
              />
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <center>
                <br />
                <strong>
                  <span v-if="org_basic_data.trust_name">{{
                    org_basic_data.trust_name
                  }}</span></strong
                ><br />
                <strong
                  ><h1 v-if="org_basic_data.trust_name">
                    {{ org_basic_data.school_name }}
                  </h1></strong
                >
                <!-- <br /> -->
                <span v-if="org_basic_data.address">{{
                  org_basic_data.address
                }}</span
                ><br />
                <span v-if="org_basic_data.phone"
                  >Phone : {{ org_basic_data.phone }}</span
                >
                <br />
                <span v-if="org_basic_data.email"
                  >Email : {{ org_basic_data.email }}</span
                >
                <br />
                <span v-if="org_basic_data.website"
                  >Website : {{ org_basic_data.website }}</span
                >
              </center>
            </v-col>
            <v-col cols="12" sm="2" md="2" align="left">
              <br />
              <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
            </v-col>
          </v-row>
          <v-row justify="center" class="ml-2">
            <v-col cols="12" sm="4" md="4">
              <strong>Affiliation No: 1130534</strong><br />
              <strong v-if="cert_data != null"
                >Sr. No. {{ cert_data.cert_no }}</strong
              >
            </v-col>
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col align="right" cols="12" sm="3" md="3"
              ><span style="margin-right: 15%"
                >Date: {{ cert_data.cert_date }}</span
              ></v-col
            >
          </v-row>
          <center>
            <strong>
              <span style="font-size: 1.3em; text-transform: uppercase"
                >To whomsoever it may concern</span
              >
            </strong>
          </center>
          <br />
          <v-row class="ml-2">
            <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
              <i>
                This is to verify that Miss / Master
                <strong
                  ><span
                    style="border-bottom: 2px solid #000; padding-bottom: 2px"
                    >{{ cert_data.stud_name }}</span
                  ></strong
                >
              </i>
              <br />
              <br />
              is / was the student of Grade
              <strong
                ><span
                  style="border-bottom: 2px solid #000; padding-bottom: 2px"
                  >{{ cert_data.std }}</span
                ></strong
              >
              Div.
              <strong
                ><span
                  style="border-bottom: 2px solid #000; padding-bottom: 2px"
                  >{{ cert_data.div }}</span
                ></strong
              >
              for the academic year
              <strong
                ><span
                  style="border-bottom: 2px solid #000; padding-bottom: 2px"
                  >{{ cert_data.ay }}</span
                ></strong
              ><br />
              <br />
              His / Her Date of birth according to our record is
              <strong
                ><span
                  style="border-bottom: 2px solid #000; padding-bottom: 2px"
                  >{{ cert_data.dob }}</span
                ></strong
              ><br />
              <br />
              His / Her address is
              <strong
                ><span
                  style="border-bottom: 2px solid #000; padding-bottom: 2px"
                  >{{ cert_data.address }}</span
                ></strong
              >
            </v-col>
            <v-col cols="12" sm="2" md="2" style="font-size: 1.3em">
              <img
                v-if="cert_data.photo != null"
                :src="awspath + cert_data.photo"
                width="75%"
                alt="logo"
              />
            </v-col>
          </v-row>
          <v-row class="ml-2">
            <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
              He / She bears a good moral character. This certificate is issued
              for Ration card / Bank account / Aadhaar Card / Caste Certificate /
              VISA / Passport.
            </v-col>
          </v-row>
          <br />
          <br /><br />
          <br /><br /><br /><br />
          <span class="bottomright" style="font-size: 1.3em"
            ><strong>PRINCIPAL</strong></span
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      snackbar: false,
      awspath: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      cert_data: null,
      div: null,
      show: true,
      org_basic_data: [],
      progress: 0,
    };
  },
  watch: {
    progress(val) {
      this.$emit("progress", val);
    },
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    close() {
      this.$router.push({ name: "certificate-bonafied", target: "blank" });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      this.cert_data = this.$route.params.cert_data;
      this.org_basic_data = this.$route.params.org_basic_data;
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.onload();
  },
};
</script>
<style scoped>
.printdiv{
  background-color: white !important;
}
.bottomright {
  position: absolute;
  bottom: 8px;
  right: 16px;
  font-size: 18px;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  img {
    width: 100% !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  .v-card {
    font-size: 2em !important;
  }
  @page {
    size: A4 landscape;
    size: 25.5in 19in;
  }
  * {
    overflow: hidden !important;
  }
}
</style>
